import React, { Component } from 'react';
import { get, has } from "lodash"

import { withStepsState } from "../../../shared/containers/containerStepsState"

import FirstTitle from '../../../shared/items/static/firstTitle';
import RadioCheckButton from '../../../shared/items/controls/radioCheckButton';
import FitnesLevelNextStepButton from "./fitnesLevelNextStepButton"
import StepContentWrapper from "./../stepContentWrapper"
import StepControl from "./../stepControl"
import { isCurrentStep, buildStepClassName, updateOpenStepState } from "../../../shared/services/service.step"
import { fitnesLevelData } from "./static.fitnesLevelData"
import { steps } from "../../../shared/static.steps"
import locales from "./../../../content.json"

import "./../../../shared/services/service.step.scss"

class FitnesLevel extends Component {
  constructor() {
    super();

    this.state = {
      isOpenFitnesLevel: false,
    }
  }

  componentDidMount() {
    if (isCurrentStep(this.props.currentIndex, steps.fitnesLevel) && !this.state.isOpenFitnesLevel)
      this.setState({ isOpenFitnesLevel: true })
  }

  componentDidUpdate(prevProps) {
    const { currentIndex, data, onSetStepData } = this.props
    const { isOpenFitnesLevel } = this.state
    const params = {
      currentIndex: currentIndex,
      prevIndex: prevProps.currentIndex,
      stepIndex: steps.fitnesLevel,
      isOpen: isOpenFitnesLevel,
      handleChange: this.handleChangeOpen.bind(this),
    }

    if (isOpenFitnesLevel && !has(data, ["fitnesLevel"]))
      onSetStepData("fitnesLevel")

    updateOpenStepState({ params })
  }

  handleChangeOpen(state) {
    this.setState({
      isOpenFitnesLevel: state,
    })
  }

  render() {
    const { currentIndex, data, onUpdateStepData } = this.props
    const { isOpenFitnesLevel } = this.state
    const params = {
      className: "wrapperFitnesLevel",
      currentIndex: currentIndex,
      stepIndex: steps.fitnesLevel,
    }

    return isOpenFitnesLevel ?
      <div className={buildStepClassName({ params })}>

        <StepContentWrapper>
          <FirstTitle>{locales[window.userLang].fitness_level_ask}</FirstTitle>

          {
            Object.keys(fitnesLevelData).map((key, index) => {
              return (
                <RadioCheckButton
                  key={index}
                  isChecked={get(data, ["fitnesLevel", "value"], null) === fitnesLevelData[key].value}
                  onClick={() => {
                    if (get(data, ["fitnesLevel", "value"], null) !== fitnesLevelData[key].value) {
                      onUpdateStepData.bind(this, "fitnesLevel", "value", fitnesLevelData[key].value)();
                      setTimeout(this.props.onToNextStep, 300);
                    }
                  }}
                >
                  {fitnesLevelData[key].title}
                </RadioCheckButton>
              )
            })
          }
        </StepContentWrapper>
      </div>
      : null
  }
}

export default withStepsState(FitnesLevel);